
import { 
    SEND_PASSWORD_RESET_EMAIL,
    SEND_PASSWORD_RESET_EMAIL_SUCCESS,
    SEND_PASSWORD_RESET_EMAIL_FAIL, 
    SEND_PASSWORD_RESET_EMAIL_RESET,
} from "../actions/sendPasswordResetEmailAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const sendPasswordResetEmailReducer = (state = initialState, action) => {
    switch (action.type) {
        case SEND_PASSWORD_RESET_EMAIL:
            return {
                ...state,
                apiState: "loading",
            };
        case SEND_PASSWORD_RESET_EMAIL_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case SEND_PASSWORD_RESET_EMAIL_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case SEND_PASSWORD_RESET_EMAIL_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default sendPasswordResetEmailReducer;
